export const LEGITIMATION_STATUS = {
    ACTIVE: 'ACTIVE',
    NONE: 'NONE',
    REVOKED: 'REVOKED',
};
